module.exports = __webpack_public_path__ + "img/five.dac61fc3.png";